<template>
  <surround
    :surround-image="surroundImage"
    :transparent="transparent"
    :title="title"
    :back-link="backLink"
  >
    <div class="info-content">
      <h1>
        {{ fulltitle }}<div
          v-if="subtitle"
          class="subtitle"
        >
          <em>{{ subtitle }}</em>
        </div>
      </h1>
      <ContentText v-if="pagesLoaded">
        <!-- eslint-disable vue/no-v-html -->
        <div v-html="pageContent" />
        <!-- eslint-enable -->
      </ContentText>
      <ContentText>
        <center v-if="routeName">
          <router-link :to="{name: routeName}">
            <img src="@/assets/arrow-right.png">
          </router-link>
        </center>
      </ContentText>
    </div>
  </surround>
</template>

<script>
// import InspirationMap from './InspirationMap.vue'
export default {
  name: 'Info',
  props: {
    page: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    routeName: {
      type: String,
      default: ''
    },
    surroundImage: {
      type: String,
      default: ''
    },
    transparent: {
      type: Boolean,
      default: false
    },
    backLink: {
      type: [String, Object, Boolean],
      default: false
    },
  },
  data() {
    return {
      pagesLoaded: false
    }
  },
  computed: {
    pageOb() {
      if (this.pagesLoaded) {
        return this.$store.getters.itemsDict.page[this.page]
      }
      return {}
    },
    pageContent() {
      return this.pageOb.content
    },
    fulltitle() {
      if (this.pageOb.display_title) {
        return this.pageOb.display_title
      }
      return this.title
    }
  },
  beforeMount() {
    this.$store.dispatch('refreshItems', 'page').then(() => {
      this.pagesLoaded = true;
    })
  }
}
</script>

<style lang="scss" scoped>
.info-content {
  @include flex-vertical;
  @include flex-fill-vertical;
  justify-content: space-around;
}
</style>
